import { render, staticRenderFns } from "./CreateInventoryRow.vue?vue&type=template&id=2450bd47"
import script from "./CreateInventoryRow.vue?vue&type=script&lang=js"
export * from "./CreateInventoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports